import { useMutation, useQueryClient } from "react-query";
import { createApiWithPath } from "../../client";
import { queryKeys } from "../../query";
import { TallyForm } from "../../types/tally";

interface ToggleArchiveResponse {
  data: { form: TallyForm };
  meta: { code: number };
}

const toggleArchive = async (
  formId: string,
): Promise<ToggleArchiveResponse> => {
  const { data } = await createApiWithPath("tally").put<ToggleArchiveResponse>(
    `/forms/${formId}/archive`,
  );
  return data;
};

export const useToggleTallyFormArchive = () => {
  const queryClient = useQueryClient();

  return useMutation((formId: string) => toggleArchive(formId), {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.tallyForms());
    },
  });
};
